// removed by extract-text-webpack-plugin
module.exports = {"menuBurgerWrapper":"-M1MZ-u_XQPrT2dv8sTKo","menuBurger":"_1s10bnoXKvcJ2I7tzyTrBF","open":"_1iSaFnq3U8oRM8ZPLGlJD1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainHeader/components/MenuBurger.mod.css
// module id = 1011
// module chunks = 0